export const isWrapperApp = () => (
  document.getElementsByTagName('body').item(0).className.includes('wrapper-app')
);
